import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loading() {
  return (
    <div className="cv-section">
      <div className="cv-container">
        <p className="cv-kicker">Loading</p>
        <div className="mt-4 h-1 w-24 bg-[#EFE9E1] overflow-hidden">
          <div className="h-full w-1/2 bg-[#A6633C] animate-pulse" />
        </div>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, ready, isAdmin } = useAuth();
  const location = useLocation();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!isAdmin)
    return (
      <div className="cv-section">
        <div className="cv-container max-w-xl">
          <p className="cv-kicker text-[#A65A43]">Restricted</p>
          <h1 className="cv-display text-3xl mt-4">Admin only</h1>
          <p className="cv-body text-[#1F1B16]/70 mt-4">
            This area is limited to the owner and admins.
          </p>
        </div>
      </div>
    );
  return children;
}
